import React from 'react';

interface ReportSectionProps {
  id: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const ReportSection: React.FC<ReportSectionProps> = ({
  id,
  title,
  subtitle,
  children,
  className = ''
}) => {
  return (
    <section id={id} className={`scroll-mt-24 ${className}`}>
      <div className="mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">{title}</h2>
        {subtitle && (
          <p className="text-lg text-gray-600">{subtitle}</p>
        )}
      </div>
      <div className="prose prose-slate max-w-none">
        {children}
      </div>
    </section>
  );
};
